import { TenantConfigurationAndRolesResponse, TenantConfigurationAndRolesResults } from './types';

type NormalizeTenantConfigurationAndRoles = (
  response: TenantConfigurationAndRolesResponse
) => TenantConfigurationAndRolesResults;
export const normalizeTenantConfigurationAndRoles: NormalizeTenantConfigurationAndRoles = (response) => {
  const numberOfCorporateCommunicators = response.data.allAdmins.edges?.length || 0;
  const numberOfLeaders = response.data.allLeaders.edges?.length || 0;
  const allLeadersHaveAudience =
    response.data.allLeaders.edges?.every(
      (edge) =>
        edge?.node?.hasNetworkWideAudience ||
        (typeof edge?.node?.audiences?.audienceCount === 'number' && edge?.node?.audiences?.audienceCount > 0)
    ) || false;

  const viewerRoles = response.data.viewer?.adminRoles || [];

  return {
    numberOfCorporateCommunicators,
    numberOfLeaders,
    allLeadersHaveAudience,
    viewerRoles,
  };
};
